var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy_1_1",
    "data-name": "copy (1) 1",
    transform: "translate(-2.167 -2.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5257",
    "data-name": "Path 5257",
    d: "M18.167,5.6v8.229a2.511,2.511,0,0,1-1.39,2.249c.009-.137.018-.274.018-.421V7.424a3.894,3.894,0,0,0-3.886-3.886H5.257A2.518,2.518,0,0,1,7.5,2.167h7.241A3.43,3.43,0,0,1,18.167,5.6Zm-5.257-.686H4.681A2.516,2.516,0,0,0,2.167,7.424v8.229a2.516,2.516,0,0,0,2.514,2.514h8.229a2.516,2.516,0,0,0,2.514-2.514V7.424A2.516,2.516,0,0,0,12.909,4.909Z",
    transform: "translate(0 0)",
    fill: "#71207c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.841864d8b1dd706883d8e08fcfd9204f.svg";
export { ForwardRef as ReactComponent };